<template>
  <div id="app">
    <div>
      <nav-bar
        :nav-options="mNavigationOption.options"
        v-on:click="onClickNav">
      </nav-bar>
    </div>
    <div>
      <router-view/>
    </div>
  </div>
</template>
<script>

import NavBar from "@/components/nav_bar"
import logger from "@/util/logger"

const LOG_TAG = 'app';

export default {
  name: LOG_TAG,
  components: {
    NavBar,
  },
  props: {
  },
  data() {
    return {
      mNavigationOption: {
        options: [
          {text: 'Customer Services', value: 'customer_services'},
          {text: 'Place Holder', value: 'place_holder_tab'},
        ],
      }
    };
  },
  created() {
    window.addEventListener('resize', () => {
      this.$store.commit('setWindowWidth');
    });
  },
  mounted() {
  },
  methods: {
    onClickNav(value) {
      const vm = this;
      logger.d(LOG_TAG, 'onClickNav', value);
      switch (value) {
        case 'customer_services':
          vm.$router.replace({name: value}, () => {});
          break;
        case 'place_holder_tab':
          vm.$router.replace({name: value}, () => {});
          break;
        case 'help':
          vm.$router.replace({name: value,}, () => {});
          break;
        case 'account':
          vm.$router.replace({name: 'account',}, () => {});
          break;
        default:
          logger.w(LOG_TAG, 'onClickNav', 'not supported', value);
      }
    },
  }
}
</script>
<style>
#app {
  font-family: "MarkPro", Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

